import React from 'react';
import { Check, Star } from 'lucide-react';
import { motion } from 'framer-motion';
const basicBenefits = ['Accedé a la masterclass y la guía', 'Usá los 3 bonos', 'Guardá el material para siempre', 'Probalo con garantía de 21 días'];
const completeBenefits = ['Recibí todo lo del Megapack PRO', 'Leé 15 casos reales de otros profesionales', 'Buscá ideas para tu propio rubro', 'Guardá el material para siempre'];
export function PricingTiers() {
  return <section id="pricing" className="bg-brand-lighter px-6 py-24 lg:px-8" data-id="element-179">
      <div className="mx-auto max-w-5xl" data-id="element-180">
        <header className="mb-16 text-center" data-id="element-181">
          <h2 className="text-3xl font-extrabold text-brand-navy md:text-5xl" data-id="element-182">
            Elegí el pack que necesitás
          </h2>
        </header>

        <div className="mx-auto grid max-w-4xl gap-8 md:grid-cols-2" data-id="element-183">
          <motion.article initial={{
          opacity: 0,
          y: 18
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="flex flex-col rounded-3xl border border-brand-light bg-white p-8 shadow-soft" data-id="element-184">
            <p className="mb-3 text-xs font-extrabold uppercase tracking-[0.16em] text-brand-accent" data-id="element-185">
              Opción 1
            </p>
            <h3 className="text-2xl font-extrabold text-brand-navy" data-id="element-186">
              Megapack PRO
            </h3>
            <p className="mt-3 min-h-[48px] text-sm font-medium text-brand-navy/65" data-id="element-187">
              Para ordenar tu negocio y cobrar mejor desde esta semana
            </p>
            <div className="my-8 flex items-baseline gap-2" data-id="element-188">
              <span className="text-4xl font-extrabold text-brand-navy" data-id="element-189">
                $19.990
              </span>
              <span className="font-bold text-brand-navy/60" data-id="element-190">ARS</span>
            </div>
            <ul className="mb-8 flex-1 space-y-4" data-id="element-191">
              {basicBenefits.map(benefit => <li key={benefit} className="flex items-start gap-3 text-brand-navy/80" data-id="element-192">
                  <Check className="mt-0.5 h-5 w-5 shrink-0 text-brand-green" data-id="element-193" />
                  {benefit}
                </li>)}
            </ul>
            <a href="https://librofy-store.myshopify.com/cart/47909760106717:1" className="block w-full rounded-xl border border-brand-accent bg-brand-light px-5 py-4 text-center font-extrabold text-brand-accent transition hover:bg-blue-100" data-id="element-194">
              Acceder al Megapack PRO
            </a>
          </motion.article>

          <motion.article initial={{
          opacity: 0,
          y: 18
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.08
        }} className="relative flex flex-col rounded-3xl border-2 border-brand-accent bg-brand-navy p-8 shadow-soft-lg md:-translate-y-4" data-id="element-195">
            <div className="absolute left-1/2 top-0 flex -translate-x-1/2 -translate-y-1/2 items-center gap-1 rounded-full bg-brand-gold px-4 py-1 text-sm font-extrabold text-brand-navy shadow-lg" data-id="element-196">
              <Star className="h-4 w-4 fill-brand-navy" data-id="element-197" /> Recomendado
            </div>
            <p className="mb-3 mt-2 text-xs font-extrabold uppercase tracking-[0.16em] text-brand-gold" data-id="element-198">
              Opción 2
            </p>
            <h3 className="text-2xl font-extrabold text-white" data-id="element-199">
              Megapack PRO + Casos de Éxito
            </h3>
            <p className="mt-3 min-h-[48px] text-sm font-medium text-white/65" data-id="element-200">
              Para los que quieren ver cómo otros lo resolvieron antes de
              aplicarlo.
            </p>
            <div className="my-8 flex items-baseline gap-2" data-id="element-201">
              <span className="text-4xl font-extrabold text-white" data-id="element-202">
                $27.990
              </span>
              <span className="font-bold text-white/60" data-id="element-203">ARS</span>
            </div>
            <ul className="mb-8 flex-1 space-y-4" data-id="element-204">
              {completeBenefits.map(benefit => <li key={benefit} className="flex items-start gap-3 text-white/90" data-id="element-205">
                  <Check className="mt-0.5 h-5 w-5 shrink-0 text-brand-green" data-id="element-206" />
                  {benefit}
                </li>)}
            </ul>
            <a href="https://librofy-store.myshopify.com/checkouts/cn/hWNDC2YhgQFxT6QjxhxL0tCE/es-ar?_r=AQABaMWEh2_MnS_qSPgGn5hiRubNit4fMT9glsLEWa7PKZs&cart_link_id=Sy4dIPgn&preview_theme_id=160306823389" className="block w-full rounded-xl bg-brand-accent px-5 py-4 text-center font-extrabold text-white shadow-lg transition hover:-translate-y-0.5 hover:bg-blue-600" data-id="element-207">
              Acceder al pack completo
            </a>
          </motion.article>
        </div>
      </div>
    </section>;
}